// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

// Product info column - handle form quantity input
if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }
  }
  customElements.define('product-info', ProductInfo);
}

// back button
if (!customElements.get('back-button')) {
  class backButton extends HTMLElement {
    constructor() {
      super();
      this.button = this;
      //Previous page
      var backLocation = document.referrer;

      // if the previous page is empty, same as current or not a muchachomalo page, go to the all collections page
      if (this.button) {
        if (
          backLocation === '' ||
          backLocation === undefined ||
          backLocation === null ||
          backLocation === window.location.href ||
          backLocation.includes('muchachomalo') == 'false'
        ) {
          backLocation = '/collections/all';
        }

        this.button.addEventListener('click', () => {
          window.location.href = backLocation;
        });
      }
    }
  }
  customElements.define('back-button', backButton);
}
